module.exports = __webpack_public_path__ + "img/notice-modal-vi-VN.cfbc1c7b.png";